import pluralize from 'pluralize';

let customPluralizeInitialized = false;

// Regras de pluralização customizadas para português brasileiro
// @deprecated use ternary operator instead
export const initializeCustomPluralizeRules = () => {
  if (customPluralizeInitialized) return;
  // Regras para singularização
  pluralize.addSingularRule(/Configurações/, 'Configuração');
  pluralize.addSingularRule(/Associações/, 'Associação');
  pluralize.addSingularRule(/Páginas/, 'Página');

  // Regras para pluralização
  pluralize.addPluralRule(/local/, 'locais');
  pluralize.addPluralRule(/devolução/, 'devoluções');

  customPluralizeInitialized = true;
};

// @deprecated use ternary operator instead
const ensureInitialized = () => {
  if (!customPluralizeInitialized) {
    initializeCustomPluralizeRules();
  }
};

// Função helper para obter o singular de uma palavra
// @deprecated use ternary operator instead
export const getSingular = (word: string): string => {
  ensureInitialized();
  return pluralize.singular(word);
};

// Função helper para obter o plural de uma palavra
// @deprecated use ternary operator instead
export const getPlural = (word: string): string => {
  ensureInitialized();
  return pluralize.plural(word);
};

// Função helper para obter o plural de uma palavra com contagem
// @deprecated use ternary operator instead
export const getPluralWithCount = (word: string, count: number): string => {
  ensureInitialized();
  return pluralize(word, count);
};

// Função helper para verificar se uma palavra é singular
// @deprecated use ternary operator instead
export const isSingular = (word: string): boolean => {
  ensureInitialized();
  return pluralize.isSingular(word);
};

// Função helper para verificar se uma palavra é plural
// @deprecated use ternary operator instead
export const isPlural = (word: string): boolean => {
  ensureInitialized();
  return pluralize.isPlural(word);
};
